export default Object.freeze({
  User: 1,
  ExternalUser: 2,
  Webhook: 3,
  ProcessInstanceActionStartProcess: 4,
  ProcessTrigger: 5,
  ScheduledProcess: 6,
  BulkTask: 7,
  Agent: 8,
  AgentOnBehalfUser: 9,
});
